import { Rule } from "@siteimprove/alfa-act";
import { video } from "../common/applicability/video.js";
import { videoTextAlternative } from "../common/expectation/media-text-alternative.js";
import { Scope, Stability } from "../tags/index.js";
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r31",
    tags: [Scope.Component, Stability.Stable],
    evaluate({ device, document }) {
        return {
            applicability() {
                return video(document, device, { audio: { has: true } });
            },
            expectations(target) {
                return videoTextAlternative(target, device);
            },
        };
    },
});
//# sourceMappingURL=rule.js.map